export default {
  chart3(state) {
    return state.chart3
  },
  chart4(state) {
    return state.chart4
  },
  chart5(state) {
    return state.chart5
  },
  chart6(state) {
    return state.chart6
  },
}
